import * as React from "react";
import { useContext, useMemo } from "react";
import { func, string } from "prop-types";
import { GridToolbarDropdown } from "./";
import { useTextDomainContext } from "@/app/providers";

export const EnergyReportDropdown = (props: any) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  const options = useMemo(
    () => [
      {
        value: "overall-statement",
        label: gettext("Annual Statement"),
      },
      {
        value: "monthly-statement",
        label: gettext("Monthly Statement"),
      },
    ],
    [gettext],
  );

  // Calculate selectedOptions using useMemo instead of state to avoid cascading renders
  const selectedOptions = useMemo(() => {
    if (typeof props.selectedOption !== "undefined") {
      return options.find((obj) => obj.value === props.selectedOption);
    }
    return undefined;
  }, [options, props.selectedOption]);

  const handleOnChange = (obj: any) => {
    if (typeof props.onChange === "function") {
      props.onChange(obj);
    }
  };

  return (
    <GridToolbarDropdown
      options={options}
      onChange={handleOnChange}
      selectedOption={selectedOptions}
    />
  );
};

EnergyReportDropdown.propTypes = {
  onChange: func,
  selectedOption: string,
};
